import styled from 'styled-components';
import {FlexCenter, interceptProps} from '@/styled-components';
import {palette} from '@/styles';

export interface SpotRoundMarkProps {
  color?: string;
  icon?: string;
  typeLabel?: string;
  hasBorder?: boolean;
}

export const SpotRoundMark = ({
  icon,
  color,
  typeLabel,
  hasBorder,
}: SpotRoundMarkProps) => {
  return (
    <Root hasBorder={hasBorder} color={color}>
      {!!icon?.length ? (
        <img src={icon} alt={typeLabel || '마커'} />
      ) : (
        (typeLabel || '').slice(0, 1)
      )}
    </Root>
  );
};

const Root = styled(FlexCenter).withConfig({
  shouldForwardProp: interceptProps(['hasBorder', 'color']),
})<{
  hasBorder?: boolean;
  color?: string;
}>`
  width: 22px;
  height: 22px;
  border-radius: 100%;
  color: ${palette.white};
  font-size: 15px;
  font-weight: 800;
  ${({color}) => !!color && `background-color: ${color};`}
  ${({hasBorder}) => hasBorder && `border: solid 1px ${palette.white};`}
  img {
    border-radius: 100%;
  }
`;
